






import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import SectionTile from "./SectionTile.vue";
import { TemplateSection } from "@/store/template/types";

@Component({
  components: {
    SectionTile
  }
})
export default class SectionList extends Vue {
  store = this.$store.direct;

  @Prop() sections!: TemplateSection[];

  get active() {
    return this.store.state.template.activeSection;
  }

  set active(val: number) {
    this.store.commit.template.SET_ACTIVE_SECTION(val);
  }
}
